// extracted by mini-css-extract-plugin
module.exports = {"modal":"BlockChainPopup_modal__3x2TY","showModal":"BlockChainPopup_showModal__jh2mV","outer":"BlockChainPopup_outer__1deHu","close":"BlockChainPopup_close__3CQtA"};